var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"h-30px bo-1px bor-100px cursor-pointer",attrs:{"ripple":"ripple"}},[_c('p',{staticClass:"lh-100 pl-22px pr-22px",class:[
      (_vm.p != '' ? ("pl-" + _vm.p + " pr-" + _vm.p) : ''), 
      (_vm.p != '' ? ("f-" + _vm.f) : 'f-14px') ]},[_vm._v(_vm._s(this.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }